import styled from "styled-components";

const CONTENT_PADDING_RIGHT = 50;

export const Container = styled.div`
    width: calc(100% - ${CONTENT_PADDING_RIGHT}px);
    padding: 0 16px 0 12px;
`;

export const ContentWrapper = styled.div<{ limitLines?: boolean }>`
    padding-top: ${(props) => props.theme.spacing.xxxSmall};
    ${(props) =>
        props.limitLines &&
        `
        line-clamp: 2;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
    `}
`;

export const BalanceValueContainer = styled.div`
    display: flex;
    :before {
        content: "\u20B9";
        margin-left: 6px;
    }
`;

export const BalanceContentWrapper = styled.div`
    display: flex;
    margin-top: 2px;
`;
